if (!customElements.get('variant-qty-selector')) {
  customElements.define(
    'variant-qty-selector',
    class extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.rows = [...this.querySelectorAll('[data-variant-row]')];
        this.totalEl = this.querySelector('[data-total]');
        this.addBtn = this.querySelector('[data-add-selected]');
        this.rrpLine = this.querySelector('[data-rrp-line]');
        this.rrpMoney = this.querySelector('[data-rrp-money]');
        this.marginWrap = this.querySelector('[data-margin-wrap]');
        this.marginPct = this.querySelector('[data-margin-pct]');

        this.rows.forEach((row) => {
          const input = row.querySelector('[data-qty-input]');
          if (row.hasAttribute('data-unavailable')) {
            input.value = 0;
          }
          row.querySelector('[data-plus]').addEventListener('click', () => this.step(row, 1));
          row.querySelector('[data-minus]').addEventListener('click', () => this.step(row, -1));
          input.addEventListener('change', () => this.normalize(row));
          this.update(row);
        });

        if (this.addBtn) this.addBtn.addEventListener('click', () => this.addToCart());
        this.hydrateRrp();
      }

      rule(row) {
        return {
          min: parseInt(row.dataset.min, 10) || 1,
          max: parseInt(row.dataset.max, 10) || Infinity,
          inc: parseInt(row.dataset.increment, 10) || 1
        };
      }

      step(row, dir) {
        const input = row.querySelector('[data-qty-input]');
        const { min, max, inc } = this.rule(row);
        let qty = parseInt(input.value, 10) || 0;

        if (dir > 0) {
          qty = qty === 0 ? min : qty + inc;
          if (qty > max) qty = max;
        } else {
          qty = qty - inc;
          if (qty < min) qty = 0;
        }
        input.value = qty;
        this.update(row);
      }

      normalize(row) {
        const input = row.querySelector('[data-qty-input]');
        const { min, max, inc } = this.rule(row);
        let qty = parseInt(input.value, 10) || 0;
        if (qty > 0) {
          if (qty < min) qty = min;
          qty = min + Math.round((qty - min) / inc) * inc;
          if (qty > max) qty = max;
        }
        input.value = qty;
        this.update(row);
      }

      update(row) {
        const qty = parseInt(row.querySelector('[data-qty-input]').value, 10) || 0;
        const price = parseInt(row.dataset.price, 10) || 0;
        const lineEl = row.querySelector('[data-line-price]');
        if (lineEl) lineEl.textContent = this.money(qty * price);
        row.classList.toggle('is-active', qty > 0);
        this.updateTotal();
        this.updateMarginLine();
      }

      updateTotal() {
        let total = 0;
        let count = 0;
        this.rows.forEach((row) => {
          const qty = parseInt(row.querySelector('[data-qty-input]').value, 10) || 0;
          total += qty * (parseInt(row.dataset.price, 10) || 0);
          if (qty > 0) count++;
        });
        if (this.totalEl) this.totalEl.textContent = this.money(total);
        if (this.addBtn) this.addBtn.disabled = count === 0;
      }

      activeUnitAndRrp() {
        let unit = parseInt(this.dataset.unitPrice, 10) || 0;
        let rrp = parseInt(this.dataset.rrp, 10) || 0;
        for (const row of this.rows) {
          const qty = parseInt(row.querySelector('[data-qty-input]').value, 10) || 0;
          if (qty > 0) {
            unit = parseInt(row.dataset.price, 10) || unit;
            const rowRrp = parseInt(row.dataset.rrp, 10) || 0;
            if (rowRrp > 0) rrp = rowRrp;
            break;
          }
        }
        if (!rrp) rrp = parseInt(this.dataset.rrp, 10) || 0;
        return { unit, rrp };
      }

      updateMarginLine() {
        if (!this.rrpLine) return;
        const { unit, rrp } = this.activeUnitAndRrp();
        if (!rrp || rrp <= 0) {
          this.rrpLine.hidden = true;
          return;
        }
        this.rrpLine.hidden = false;
        if (this.rrpMoney) this.rrpMoney.textContent = this.money(rrp);
        if (this.marginWrap && this.marginPct) {
          if (unit > 0 && rrp > unit) {
            const margin = Math.round(((rrp - unit) * 100) / rrp);
            this.marginWrap.hidden = false;
            this.marginPct.textContent = margin + '%';
          } else {
            this.marginWrap.hidden = true;
          }
        }
      }

      hydrateRrp() {
        const current = parseInt(this.dataset.rrp, 10) || 0;
        const applyRowDisplays = () => {
          this.rows.forEach((row) => {
            const price = parseInt(row.dataset.price, 10) || 0;
            const rrp = parseInt(row.dataset.rrp, 10) || 0;
            const compareEl = row.querySelector('[data-compare-at]');
            const marginEl = row.querySelector('[data-row-margin]');
            if (compareEl) {
              if (rrp > price) {
                compareEl.hidden = false;
                compareEl.textContent = this.money(rrp);
              } else {
                compareEl.hidden = true;
              }
            }
            if (marginEl) {
              if (rrp > price && price > 0) {
                marginEl.hidden = false;
                marginEl.textContent = Math.round(((rrp - price) * 100) / rrp) + '% margin';
              } else {
                marginEl.hidden = true;
              }
            }
          });
          this.updateMarginLine();
        };

        if (current > 0) {
          applyRowDisplays();
          return;
        }
        const handle = this.dataset.productHandle;
        if (!handle) return;

        fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'omit',
          headers: { Accept: 'application/json' }
        })
          .then((res) => (res.ok ? res.json() : null))
          .then((data) => {
            if (!data || !data.variants || !data.variants.length) return;
            let maxRrp = 0;
            data.variants.forEach((v) => {
              const cap = Number(v.compare_at_price) || 0;
              if (cap > maxRrp) maxRrp = cap;
            });
            if (!maxRrp && data.compare_at_price) {
              maxRrp = Number(data.compare_at_price) || 0;
            }
            if (!maxRrp) return;
            this.dataset.rrp = String(maxRrp);
            this.rows.forEach((row) => {
              const vid = String(row.dataset.variantId);
              const match = data.variants.find((v) => String(v.id) === vid);
              const cap = match && match.compare_at_price ? Number(match.compare_at_price) : maxRrp;
              if (cap > 0) row.dataset.rrp = String(cap);
            });
            applyRowDisplays();
          })
          .catch(() => {});
      }

      money(cents) {
        cents = Math.round(Number(cents) || 0);
        const value = (cents / 100).toFixed(2);
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && this.moneyFormat) {
          return window.Shopify.formatMoney(cents, this.moneyFormat);
        }
        return this.moneyFormat
          ? this.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, value)
          : '$' + value;
      }

      async addToCart() {
        const items = this.rows
          .filter((row) => !row.hasAttribute('data-unavailable'))
          .map((row) => ({
            id: parseInt(row.dataset.variantId, 10),
            quantity: parseInt(row.querySelector('[data-qty-input]').value, 10) || 0
          }))
          .filter((i) => i.quantity > 0);
        if (!items.length) return;

        this.addBtn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!res.ok) throw new Error((await res.json()).description || 'Add to cart failed');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.location.href = '/cart';
        } catch (e) {
          alert(e.message);
          this.addBtn.disabled = false;
        }
      }
    }
  );
}
